import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsCardModel from './pcs-card.ts';
import type PcsAuthorizationModel from './pcs-authorization.ts';

export default class PcsTransactionModel extends Model {
  @attr declare provider: string;
  @attr declare providerId: string;
  @attr declare providerData: Record<string, unknown>;
  @attr declare state: string;
  @attr declare transitionLog: Record<string, unknown>;
  @attr declare amount: number;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-card', { async: false, inverse: 'pcsTransactions' })
  declare pcsCard: PcsCardModel;

  @belongsTo('pcs-authorization', { async: false, inverse: null })
  declare pcsAuthorization: PcsAuthorizationModel | null;

  [Type] = 'pcs-transaction' as const;
}
